import { service } from '@ember/service';
import Component from '@glimmer/component';
import { dropTask } from 'ember-concurrency';
import type FlowModel from 'garaje/models/flow';
import type LocationModel from 'garaje/models/location';
import type FlashMessagesService from 'garaje/services/flash-messages';
import type MetricsService from 'garaje/services/metrics';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';

interface VisitorSurveyComponentSignature {
  Args: {
    flow: FlowModel;
    location: LocationModel;
    readOnly: boolean;
    surveyEnabled: boolean;
  };
}

export default class VisitorSurveyComponent extends Component<VisitorSurveyComponentSignature> {
  @service declare flashMessages: FlashMessagesService;
  @service declare metrics: MetricsService;

  updateFlowSurveyConfigAndSave = dropTask(async (value: boolean = false) => {
    this.args.flow.visitorSurveyEnabled = value;
    const actionName = value === true ? 'enabled' : 'disabled';
    const msg = `Survey email ${actionName} for ${this.args.flow.name}`;
    try {
      await this.args.flow.save();
      const name = value ? 'Survey Enabled - Flow' : 'Survey Disabled - Flow';
      this.metrics.trackEvent(name, {
        flow_id: this.args.flow.id,
        flow_name: this.args.flow.name,
        location_id: this.args.location.id,
        location_name: this.args.location.name,
      });
      this.flashMessages.showAndHideFlash('success', msg);
    } catch (e) {
      this.flashMessages.showFlash('error', parseErrorForDisplay(e));
    }
  });
}
